export default function IdeaSelector({ ideas, selectedId, onSelect }) {
  if (!ideas.length) {
    return (
      <div className="text-center py-8 text-gray-400">
        <p className="text-sm">No ideas in your vault yet</p>
        <p className="text-xs mt-1">Add ideas to your vault first, then come back to find company matches</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700 mb-2">Select an idea to match</label>
      {ideas.map(idea => {
        const profile = idea.idea_profiles?.[0] || idea.idea_profiles;
        const isSelected = selectedId === idea.id;

        return (
          <button
            key={idea.id}
            onClick={() => onSelect(idea.id)}
            className={`w-full text-left p-4 rounded-xl border transition-all ${
              isSelected
                ? 'border-vault-gold bg-yellow-50 shadow-sm'
                : 'border-vault-border bg-white hover:border-gray-300'
            }`}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-vault-navy text-sm">{idea.title}</div>
                {idea.description && (
                  <div className="text-xs text-gray-500 mt-0.5 line-clamp-1">{idea.description}</div>
                )}
              </div>
              <div className="flex gap-1.5 ml-3">
                {profile?.product_category && (
                  <span className="text-xs px-2 py-0.5 bg-vault-surface rounded-full text-gray-500 capitalize">
                    {profile.product_category.replace(/_/g, ' ')}
                  </span>
                )}
                {idea.status && (
                  <span className="text-xs px-2 py-0.5 bg-vault-surface rounded-full text-gray-500 capitalize">
                    {idea.status}
                  </span>
                )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
